import { Translate } from '@chipinside/translate'
import { Link } from 'react-router-dom'

import { CollarStatus } from '#/@types/backend'
import CowmedChip from '#/components/Chip'
import { Icon } from '#/components/Icon'
import { useFarmSlug } from '#/store/ducks/farm'
import { usePermissions } from '#/store/ducks/permissions'
import useAppContext from '#/store/hooks/useAppContext'
import { PageId } from '#/store/services/Pages/PagesService'
import Colors from '#/styles/Colors'
import { getLink } from '#/utils/getLink'

interface ICollarBadgeProps {
  linkTo?: PageId
  params?: Record<string, string>
  value?: ICollarProps
}

export interface ICollarProps {
  code: number
  baby?: boolean
  status?: {
    status: CollarStatus
    text?: string
  }
}

const TypeCollar = ({ linkTo, params, value }: ICollarBadgeProps) => {
  const farmSlug = useFarmSlug()
  const context = useAppContext()
  const permissions = usePermissions()
  if (!value) return <>-</>

  const { baby, code } = value
  const status = value?.status?.status

  const isFarmContext = context === 'farm'
  const defaultLink = isFarmContext
    ? 'farm-monitoring-c-tech-collar-report-map'
    : 'system-inventory-c-tech-collar-report-map'

  const id = linkTo ?? defaultLink

  const link = getLink({
    id,
    params: { ctech: String(code), farm: farmSlug ?? params?.farmSlug },
  })

  const title = getCollarTitle({ link, status })

  const collarStyle = getCollarColor({ permissions, status })

  /**
   * Cria props de link quando o getLink retorna uma pagina
   */
  const linkProps = link && {
    component: Link,
    to: link,
    tooltip: title,
  }

  return (
    <CowmedChip
      {...linkProps}
      icon={
        baby ? <Icon size="large" name="cow-baby" style={{ color: 'currentColor' }} /> : undefined
      }
      value={code}
      style={{ ...collarStyle, cursor: link ? 'pointer' : 'auto' }}
      width="unset"
    />
  )
}

export default TypeCollar

const getCollarColor = ({ permissions, status }) => {
  // Se não tem status, retorna cinza
  if (!status) {
    return Colors.devices.ctech.without_status
  }

  // Se não tem permissão para ver os status então retorna sempre azul(normal)
  if (!(
    permissions.farm.view_collar_status_report || permissions.system.view_collar_status_report
  )) {
    return Colors.devices.ctech.normal
  }

  // Retorna cor baseada no status
  return Colors.devices.ctech[status]
}

const getCollarTitle = ({ link, status }) => {
  // Se não tem status, retorna "Sem informação"
  if (!status) {
    return Translate({ messageKey: 'without_information' })
  }

  // Se possui link, retorna "Acessar coleira"
  if (link) {
    return Translate({
      messageKey: 'access_item',
      params: { item: Translate({ lower: true, messageKey: 'collar' }) },
    })
  }
}
